// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CrenteDetails.module.css */
.CrenteDetails_detailsContainer__x3mxU {
    background-color: #ffffff;
    padding: 20px;
    border-radius: 12px;
    color: #1e1e1e;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
    max-width: 100%;
    margin-top: 30px;
    transition: background 0.3s ease, transform 0.3s ease;
    height: 97%;
    overflow: hidden;
}

.CrenteDetails_header__D\\+Db0 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.CrenteDetails_header__D\\+Db0 h1 {
    margin: 0;
    font-size: 35px;
    font-weight: 600;
}

.CrenteDetails_editButton__usraz {
    background-color: #074273;
    border: none;
    color: #ffffff;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.3s ease, transform 0.2s ease;
}

.CrenteDetails_editButton__usraz:hover {
    background-color: #00a0e4;
    transform: scale(1.05);
}

.CrenteDetails_tabContainer__ndxr8 {
    display: flex;
    border-bottom: 1px solid #555;
    margin-bottom: 20px;
}

.CrenteDetails_tab__h4aDl {
    background: none;
    border: none;
    padding: 12px 24px;
    cursor: pointer;
    color: #1e1e1e;
    font-size: 18px;
    transition: background 0.3s ease;
}

.CrenteDetails_tab__h4aDl:hover {
    color: #074273;
    transform: scale(1.05);
}

.CrenteDetails_activeTab__w5503 {
    border-bottom: 3px solid #074273;
}

.CrenteDetails_content__aDoWv {
    padding-top: 20px;
}

.CrenteDetails_noSelection__Gredh {
    text-align: center;
    font-size: 20px;
    color: #e0e0e0;
    margin-top: 60px;
}`, "",{"version":3,"sources":["webpack://./src/components/LIFTrac/Crentes/CrenteDetails.module.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,qDAAqD;IACrD,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,qDAAqD;AACzD;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB","sourcesContent":["/* CrenteDetails.module.css */\r\n.detailsContainer {\r\n    background-color: #ffffff;\r\n    padding: 20px;\r\n    border-radius: 12px;\r\n    color: #1e1e1e;\r\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);\r\n    max-width: 100%;\r\n    margin-top: 30px;\r\n    transition: background 0.3s ease, transform 0.3s ease;\r\n    height: 97%;\r\n    overflow: hidden;\r\n}\r\n\r\n.header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.header h1 {\r\n    margin: 0;\r\n    font-size: 35px;\r\n    font-weight: 600;\r\n}\r\n\r\n.editButton {\r\n    background-color: #074273;\r\n    border: none;\r\n    color: #ffffff;\r\n    padding: 10px 20px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    transition: background 0.3s ease, transform 0.2s ease;\r\n}\r\n\r\n.editButton:hover {\r\n    background-color: #00a0e4;\r\n    transform: scale(1.05);\r\n}\r\n\r\n.tabContainer {\r\n    display: flex;\r\n    border-bottom: 1px solid #555;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.tab {\r\n    background: none;\r\n    border: none;\r\n    padding: 12px 24px;\r\n    cursor: pointer;\r\n    color: #1e1e1e;\r\n    font-size: 18px;\r\n    transition: background 0.3s ease;\r\n}\r\n\r\n.tab:hover {\r\n    color: #074273;\r\n    transform: scale(1.05);\r\n}\r\n\r\n.activeTab {\r\n    border-bottom: 3px solid #074273;\r\n}\r\n\r\n.content {\r\n    padding-top: 20px;\r\n}\r\n\r\n.noSelection {\r\n    text-align: center;\r\n    font-size: 20px;\r\n    color: #e0e0e0;\r\n    margin-top: 60px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"detailsContainer": `CrenteDetails_detailsContainer__x3mxU`,
	"header": `CrenteDetails_header__D+Db0`,
	"editButton": `CrenteDetails_editButton__usraz`,
	"tabContainer": `CrenteDetails_tabContainer__ndxr8`,
	"tab": `CrenteDetails_tab__h4aDl`,
	"activeTab": `CrenteDetails_activeTab__w5503`,
	"content": `CrenteDetails_content__aDoWv`,
	"noSelection": `CrenteDetails_noSelection__Gredh`
};
export default ___CSS_LOADER_EXPORT___;
